/**
 * 全ページ共通 定数ファイル
 */

 let gv_cons = nsOiOi.cons;

 (()=> {

	gv_cons.MARUI_DOMAIN = location.hostname.indexOf('www.0101.co.jp') === 0 ? 'https://www.0101.co.jp' : 'https://stg.0101.co.jp';
	gv_cons.RELEASE_DOMAIN	= [
		'www.0101.co.jp',
		'www.0101.co.jp.e.ex.hp.transer.com',
		'www.0101.co.jp.t.ex.hp.transer.com',
		'www.0101.co.jp.c.ex.hp.transer.com',
		'www.0101.co.jp.k.ex.hp.transer.com',
		'www-origin.0101.co.jp'
	];
	gv_cons.RELEASE_DOMAIN_REGEXP = /.*?\.0101\.co\.jp$/;
	gv_cons.DEBUG_DIR_PATH	= '/marui-utils/xml-load/?url=';

	/** 画像種別 (getFilePath / imgDataPath の第2引数で使用) */
	gv_cons.IMG_TYPE = {
		ORIGIN : '',
		AUTO   : 'auto',
		JPG    : '.jpg',
		WEBP_M : '_m.webp',
		WEBP_L : '_l.webp'
	};

	gv_cons.TRANSER_CREATE_DOMAIN_MASTER = {
		production : {
			'en'	: 'https://www.0101.co.jp.e.ex.hp.transer.com',
			'zh'	: 'https://www.0101.co.jp.t.ex.hp.transer.com',
			'cn'	: 'https://www.0101.co.jp.c.ex.hp.transer.com',
			'ko'	: 'https://www.0101.co.jp.k.ex.hp.transer.com',
			'jp'	: 'https://www.0101.co.jp',
		},
		dev			: {
			'en'	: '.e.sc.hp.transer.com',
			'zh'	: '.t.sc.hp.transer.com',
			'cn'	: '.c.sc.hp.transer.com',
			'ko'	: '.k.sc.hp.transer.com',
			'jp'	: '',
		},
	};

	gv_cons.EC_SITE_URL_ARY = [
		/^https?:\/\/voi.0101.co.jp\/.*/,
		/^https?:\/\/search-voi.0101.co.jp\/.*/,
	];

	gv_cons.TRANSER_DOMAIN_MASTER = {
		en : /.*?\.e\.sc\.hp\.transer\.com$|.*?\.e\.ex\.hp\.transer\.com$/,
		zh : /.*?\.t\.sc\.hp\.transer\.com$|.*?\.t\.ex\.hp\.transer\.com$/,
		cn : /.*?\.c\.sc\.hp\.transer\.com$|.*?\.c\.ex\.hp\.transer\.com$/,
		ko : /.*?\.k\.sc\.hp\.transer\.com$|.*?\.k\.ex\.hp\.transer\.com$/,
	};

	gv_cons.TRANSER_DOMAIN_EN = /.*?\.e\.sc\.hp\.transer\.com$|.*?\.e\.ex\.hp\.transer\.com$/;
	gv_cons.TRANSER_DOMAIN_ZH = /.*?\.t\.sc\.hp\.transer\.com$|.*?\.t\.ex\.hp\.transer\.com$/;
	gv_cons.TRANSER_DOMAIN_CN = /.*?\.c\.sc\.hp\.transer\.com$|.*?\.c\.ex\.hp\.transer\.com$/;
	gv_cons.TRANSER_DOMAIN_KO = /.*?\.k\.sc\.hp\.transer\.com$|.*?\.k\.ex\.hp\.transer\.com$/;

	gv_cons.TRANSER_CONTENTS_MASTER = {
		en : 'section.language-en',
		zh : 'section.language-zh',
		cn : 'section.language-cn',
		ko : 'section.language-ko',
	};

	gv_cons.TRANSER_COMMON_DISP_ELEM = '.language-only';

	gv_cons.TRANSER_LINK_MASTER = {
		production : {
			'.h-language-en' : '.e.ex.hp.transer.com',
			'.h-language-zh' : '.t.ex.hp.transer.com',
			'.h-language-cn' : '.c.ex.hp.transer.com',
			'.h-language-ko' : '.k.ex.hp.transer.com',
		},
		dev : {
			'.h-language-en' : '.e.sc.hp.transer.com',
			'.h-language-zh' : '.t.sc.hp.transer.com',
			'.h-language-cn' : '.c.sc.hp.transer.com',
			'.h-language-ko' : '.k.sc.hp.transer.com',
		}
	};

	gv_cons.TRANSER_BRIDGE_PAGE = {
		'transer_en.html' : 'en',
		'transer_cn.html' : 'cn',
		'transer_zh.html' : 'zh',
		'transer_ko.html' : 'ko',
	};

	gv_cons.TRANSER_BRIDGE_MASTER = {
		production : {
			'en' : '.e.ex.hp.transer.com',
			'zh' : '.t.ex.hp.transer.com',
			'cn' : '.c.ex.hp.transer.com',
			'ko' : '.k.ex.hp.transer.com',
		},
		dev : {
			'en' : '.e.sc.hp.transer.com',
			'zh' : '.t.sc.hp.transer.com',
			'cn' : '.c.sc.hp.transer.com',
			'ko' : '.k.sc.hp.transer.com',
		}
	};

	gv_cons.BROWSER_LANG_KEY = {
		'jp'   : /^jp(-.*|$)/,
		'en'   : /^en(-.*|$)/,
		'zh'   : /^zh-TW/,
		'cn'   : /^zh-CN/,
		'ko'   : /^ko(-.*|$)/
	};

	gv_cons.TRANSER_ALL_ADD_DOMAIN = [
		/(.*)\.e\.(ex|sc)\.hp\.transer\.com/,
		/(.*)\.t\.(ex|sc)\.hp\.transer\.com/,
		/(.*)\.c\.(ex|sc)\.hp\.transer\.com/,
		/(.*)\.k\.(ex|sc)\.hp\.transer\.com/
	];

	gv_cons.TRANSER_JP = 'jp';
	gv_cons.TRANSER_EN = 'en';
	gv_cons.TRANSER_ZH = 'zh';
	gv_cons.TRANSER_CN = 'cn';
	gv_cons.TRANSER_KO = 'ko';

	gv_cons.TRANSER_GNAVI_LINK_EXCEPTION = [
		{
			targetPathRegExp : /^(\/|\/index\.html)$/,
			replacePath		 : '/global/${lang}.html'
		},
		{
			targetPathRegExp : /\/global\/about\/(en|zh|cn|ko)\.html/,
			replacePath		 : '/global/about/${lang}.html'
		},
		{
			targetPathRegExp : /\/global\/(en|zh|cn|ko)\.html/,
			replacePath		 : '/global/${lang}.html'
		}
	];


	gv_cons.RELEASE_TARGET_DOMAIN = [
		'www.0101.co.jp',
		'hakata-fan.0101.co.jp',
		'www.0101maruigroup.co.jp',
		'www.0101.co.jp.e.ex.hp.transer.com',
		'www.0101.co.jp.t.ex.hp.transer.com',
		'www.0101.co.jp.c.ex.hp.transer.com',
		'www.0101.co.jp.k.ex.hp.transer.com',
		'review.0101.co.jp',
		'www.01field.jp,',
		'home.0101.co.jp',
		'01food.0101.co.jp',
		'intheroom.jp',
		'standard.navitime.biz',
		'bizsearch-asp.accelatech.com',
		'0101hakama.com',
	];

	gv_cons.HTTP_URL_MARUI_REGEXP = /^https?:\/\/www\.0101\.co\.jp/;
	gv_cons.HTTP_URL_REGEXP = /^https?:\/\/.*/;

	gv_cons.IDENTIFY_TTS_ANNOUNCE	= 'an';
	gv_cons.IDENTIFY_TTS_BNRLIST	= 'bn';
	gv_cons.IDENTIFY_TTS_CAMPAIGN	= 'ca';
	gv_cons.IDENTIFY_TTS_COUPON		= 'co';
	gv_cons.IDENTIFY_TTS_FACILITY	= 'fa';
	gv_cons.IDENTIFY_TTS_FEATURE	= 'fe';
	gv_cons.IDENTIFY_TTS_FLOORMAP	= 'fm';
	gv_cons.IDENTIFY_TTS_SHOPMASTER	= 'sm';
	gv_cons.IDENTIFY_TTS_SHOPINTRO	= 'si';
	gv_cons.IDENTIFY_TTS_SHOPNEWS	= 'sn';
	gv_cons.IDENTIFY_TTS_STORENEWS	= 'st';

	gv_cons.MEDIA_QUERY_SP = window.matchMedia('screen and (max-width:767px)');

	/** ネット通販API連携 */
	gv_cons.BASE_WC_LINK_URI        = 'https://search-voi.0101.co.jp/';
	gv_cons.BASE_WC_API_URI         = 'https://search-voi.0101.co.jp/api/search';
	gv_cons.BASE_WC_API_URI_RANKING = 'https://search-voi.0101.co.jp/api/ranking';
	// gv_cons.BASE_WC_API_URL_SHOP	  = 'https://search-voi.0101.co.jp/voi/search.do';
	gv_cons.BASE_WC_API_URL_WORD	  = 'https://search-voi.0101.co.jp/freeword/';
	gv_cons.EC_API_DEFAULT_OPTION	  = {
		factor	: 'shop',
		per	: 30,
	};

	gv_cons.FONT_SIZE_MASTER = {
		'big'		: '120%',
		'middle'	: '100%',
		'small'		: '80%'
	};

	gv_cons.FONT_SIZE_COOKIE_MASTER = {
		'big'		: '1',
		'middle'	: '2',
		'small'		: '3'
	};

	/** リンク遷移タイプ */
	gv_cons.LINK_TYPE_CLASS_NAME = {
		'01'	: 'normal-link',
		'02'	: 'outer-link',
		'03'	: 'popup-link',
		'04'	: 'popup-link',
	}

	gv_cons.LINK_TYPE_MASTER_PC = {
		'01' : {
			attr	: 'target',
			value	: '_self',
		},
		'02' : {
			attr	: 'target',
			value	: '_blank',
		},
		'03' : {
			attr	: 'data-link',
			value	: 'popup-s',
		},
		'04' : {
			attr	: 'data-link',
			value	: 'popup-l',
		},
	};

	gv_cons.LINK_TYPE_MASTER_SP = {
		'01' : {
			attr	: 'target',
			value	: '_self',
		},
		'02' : {
			attr	: 'target',
			value	: '_blank',
		},
		'03' : {
			attr	: 'target',
			value	: '_blank',
		},
		'04' : {
			attr	: 'target',
			value	: '_blank',
		},
	};

	gv_cons.LINK_CLASS_MASTER_PC = {
		'01'	: 'inner-link',
		'02'	: 'outer-link',
		'03'	: 'popup-link',
		'04'	: 'popup-link',
	};

	gv_cons.LINK_CLASS_MASTER_SP = {
		'01'	: 'inner-link',
		'02'	: 'outer-link',
		'03'	: 'outer-link',
		'04'	: 'outer-link',
	};

	/** 記事区分　遷移先ディレクトリ */
	gv_cons.ARTICLE_CLASS_SHOP_NEWS		= '04';
	gv_cons.ARTICLE_DIR_MASTER = {
		'01'	: '/store-info/fair.html',
		'02'	: '/store-info/news.html',
		'03'	: '/store-info/feature.html',
		'04'	: '/shop-news/detail.html',
	};

	/** イベント最大終了日 */
	gv_cons.EVENT_MAX_END_DATE		= '9999/12/31';
	gv_cons.EVENT_MAX_END_DATE_STR	= '99991231';

	gv_cons.TTS_XML_DIR	= {
		an : '/contents2/announce/${stcd}/emgncy_announce_list.xml',
		bn : '/contents2/banner/${stcd}/banner_list.xml',
		ca : '/contents2/campaign/${stcd}/campaign_list.xml',
		co : '/contents2/coupon/${stcd}/coupon_list.xml',
		fa : '/contents2/facilityinfo/${stcd}/facility.xml',
		fe : '/contents2/feature/${stcd}/feature_article_list.xml',
		fm : '/contents2/floormap/${stcd}/floor_map_list.xml',
		sm : '/contents2/shopinfo/${stcd}/shop_list.xml',
		si : '/contents2/shopinfo/${stcd}/shop_introduce_list.xml',
		sn : '/contents2/shopnews/${stcd}/shop_article_list.xml',
		st : '/contents2/storenews/${stcd}/store_article_list.xml',
	};

	gv_cons.TTS_JSON_DIR	= {
		an : '/contents2/announce/${stcd}/emgncy_announce_list.json',
		bn : '/contents2/banner/${stcd}/banner_list.json',
		ca : '/contents2/campaign/${stcd}/campaign_list.json',
		co : '/contents2/coupon/${stcd}/coupon_list.json',
		fa : '/contents2/facilityinfo/${stcd}/facility.json',
		fe : '/contents2/feature/${stcd}/feature_article_list.json',
		fm : '/contents2/floormap/${stcd}/floor_map_list.json',
		sm : '/contents2/shopinfo/${stcd}/shop_list.json',
		si : '/contents2/shopinfo/${stcd}/shop_introduce_list.json',
		sn : '/contents2/shopnews/${stcd}/shop_article_list.json',
		st : '/contents2/storenews/${stcd}/store_article_list.json',
		ae : '/contents2/anime/${stcd}/${shopCode}.json',
	};


	/** WEB投稿ステータス */
	gv_cons.WEB_POST_FLAG_OK	= '1';
	gv_cons.WEB_POST_FLAG_NG	= '0';

	/** WEB一覧表示フラグ */
	gv_cons.DISP_LIST_FLAG_OK	= '0';
	gv_cons.DISP_LIST_FLAG_NG	= '1';


	/** カテゴリークラス名 */
	gv_cons.SHOP_CATEGORY_CLASS	= {
		'全て表示'						: 'all',
		'レディス'						: 'ladies',
		'メンズ'						: 'mens',
		'レディス＆メンズ'				: 'ladiesmens',
		'ファミリー'						: 'family',
		'キッズ'						: 'kids',
		'ファッション雑貨・生活雑貨'		: 'sundries',
		'スポーツ・アウトドア'			: 'sports',
		'コスメ・ビューティ'				: 'beauty',
		'グルメ・フード'					: 'gourmet',
		'サービス・エンターテイメント'	: 'service',
	};

	/**  ニュース＆トピックスカテゴリ */
	gv_cons.STORE_TOP_NEWS_TOPICS_CATEGORY = {
		'01' : 'event',
		'02' : 'store',
		'03' : 'store'
	};

	gv_cons.STORE_TOP_NEWS_TOPICS_CATEGORY_NAME = {
		event : 'イベント',
		store : '店舗',
		shop  : 'ショップ',
		coupon: 'クーポン'
	};

	gv_cons.STORE_ARTICLE_CLASS_OBJ		= {
		'00'	: '全て表示',
		'01'	: '期間限定ショップ',
		'02'	: 'お知らせ',
		'03'	: '特集',
	};

	/** ショップニュース記事区分 */
	gv_cons.SHOP_ARTICLE_CLASS_OBJ		= {
		'00'	: '全て表示',
		'01'	: 'おすすめ',
		'02'	: 'お得情報',
		'03'	: 'お知らせ',
	};

	gv_cons.BNR_CLASS_PB = '01'; // プライベートブランド
	gv_cons.BNR_CLASS_TR = '02'; // トップローテ
	gv_cons.BNR_CLASS_EC = '03'; // ネット通販バナー
	gv_cons.BNR_CLASS_NT = '04'; // ニュース＆トピックス

	// 記事公開日から加算日数までの期間NEWフラグを設定
	gv_cons.NEWS_TOPICS_NEW_DATE = 7;

	// NEWS＆TOPICS　表示文字制限 ※インデックス番号
	gv_cons.NEWS_TOPICS_LIMIT_STR = 16;
	gv_cons.NEWS_TOPICS_LIMIT_STR_IDX = 15;

	gv_cons.STORE_CODE_MASTER = {
		'086' : '有楽町マルイ',
		'003' : '新宿マルイ 本館',
		'005' : '新宿マルイ アネックス',
		'074' : '新宿マルイ メン',
		'013' : '渋谷マルイ',
		'058' : '上野マルイ',
		'054' : '錦糸町マルイ',
		'001' : '中野マルイ',
		'016' : '吉祥寺マルイ',
		'062' : '国分寺マルイ',
		'052' : '町田マルイ',
		'077' : 'マルイシティ横浜',
		'082' : '海老名マルイ',
		'076' : '柏マルイ',
		// '088' : '京都マルイ',
		'036' : '静岡マルイ',
		'048' : '池袋マルイ',
		'084' : '北千住マルイ',
		'001' : '中野マルイ',
		// '061' : '丸井川崎店',
		'078' : 'マルイファミリー溝口',
		'053' : '大宮マルイ',
		'079' : 'マルイファミリー志木',
		'066' : '草加マルイ',
		'085' : 'なんばマルイ',
		'083' : '神戸マルイ',
		'041' : '丸井水戸店',
		'060' : '戸塚モディ(まるい食遊館戸塚店)',
		'090' : '博多マルイ',
		'403' : 'マルイノアニメ',
		'201' : '丸井の専門店',
		'202' : '丸井のアウトレット',
		'203' : '体験ストア',
		'722' : '柏モディ',
		'723' : '町田モディ',
		'724' : '静岡モディ',
		'721' : '渋谷モディ',
		'726' : '川越モディ',
		'111' : '全店TOP',
		'997' : '研修用店舗',
	};

	gv_cons.STORE_CODE_SORT_MASTER = [
		'086',
		'003',
		'005',
		'074',
		'013',
		'721',
		'048',
		'058',
		'084',
		'054',
		'001',
		'016',
		'062',
		'052',
		'723',
		'077',
		'078',
		'082',
		'060',
		'053',
		'079',
		'066',
		'726',
		'076',
		'722',
		'041',
		'085',
		'083',
		'088',
		'036',
		'724',
		'090',
		'201',
		'202'
	];

	gv_cons.STORE_LIST_CODE_MASTER = {
		'086' : '有楽町マルイ',
		'003' : '新宿マルイ 本館',
		'005' : '新宿マルイ アネックス',
		'074' : '新宿マルイ メン',
		'013' : '渋谷マルイ',
		'721' : '渋谷モディ',
		'058' : '上野マルイ',
		'054' : '錦糸町マルイ',
		'001' : '中野マルイ',
		'016' : '吉祥寺マルイ',
		'062' : '国分寺マルイ',
		'052' : '町田マルイ',
		'723' : '町田モディ',
		'077' : 'マルイシティ横浜',
		'082' : '海老名マルイ',
		'060' : '戸塚モディ(まるい食遊館戸塚店)',
		'076' : '柏マルイ',
		'722' : '柏モディ',
		// '088' : '京都マルイ',
		// '036' : '静岡マルイ',
		'724' : '静岡モディ',
		// '048' : '池袋マルイ',
		'084' : '北千住マルイ',
		'001' : '中野マルイ',
		'078' : 'マルイファミリー溝口',
		'053' : '大宮マルイ',
		'079' : 'マルイファミリー志木',
		'066' : '草加マルイ',
		// '726' : '川越モディ',
		'085' : 'なんばマルイ',
		'083' : '神戸マルイ',
		// '041' : '丸井水戸店',
		'090' : '博多マルイ',
	};

	/** 店舗コード */
	gv_cons.STORE_NUMBER_SHINJYUKU		= '003';
	gv_cons.STORE_NUMBER_KYOTO			= '088';
	gv_cons.STORE_NUMBER_YURAKUCHO		= '086';
	gv_cons.STORE_NUMBER_MIZONOKUCHI	= '078';
	gv_cons.STORE_NUMBER_SHIBUYA		= '013';
	gv_cons.STORE_NUMBER_IKEBUKURO		= '048';
	gv_cons.STORE_NUMBER_YOKOHAMA		= '077';
	gv_cons.STORE_NUMBER_KITASENJYU		= '084';
	gv_cons.STORE_NUMBER_SHINJYUKU_MEN	= '074';
	gv_cons.STORE_NUMBER_SOUKA			= '066';
	gv_cons.STORE_NUMBER_KOKUBUNJI		= '062';
	gv_cons.STORE_NUMBER_KAWASAKI		= '061';
	gv_cons.STORE_NUMBER_TOTSUKA		= '060';
	gv_cons.STORE_NUMBER_UENO			= '058';
	gv_cons.STORE_NUMBER_KINSHICHO		= '054';
	gv_cons.STORE_NUMBER_OOMIYA			= '053';
	gv_cons.STORE_NUMBER_MACHIDA		= '052';
	gv_cons.STORE_NUMBER_EBINA			= '082';
	gv_cons.STORE_NUMBER_MITO			= '041';
	gv_cons.STORE_NUMBER_SHIKI			= '079';
	gv_cons.STORE_NUMBER_SHIZUOKA		= '036';
	gv_cons.STORE_NUMBER_KASHIWA		= '076';
	gv_cons.STORE_NUMBER_KICHIJYOJI		= '016';
	gv_cons.STORE_NUMBER_SHINJYUKU_ANNEX	= '005';
	gv_cons.STORE_NUMBER_NAKANO			= '001';
	gv_cons.STORE_NUMBER_NAMBA			= '085';
	gv_cons.STORE_NUMBER_KOUBE			= '083';
	gv_cons.STORE_NUMBER_HAKATA			= '090';
	gv_cons.STORE_NUMBER_OUTLET			= '000';
	gv_cons.STORE_NUMBER_SENMONTEN		= '000';
	gv_cons.STORE_NUMBER_SHIBUYA_MODI	= '721';
	gv_cons.STORE_NUMBER_KASHIWA_MODI	= '722';
	gv_cons.STORE_NUMBER_MACHIDA_MODI	= '723';
	gv_cons.STORE_NUMBER_SHIZUOKA_MODI	= '724';
	gv_cons.STORE_NUMBER_KAWAGOE_MODI	= '726';
	gv_cons.STORE_NUMBER_MARUI_ANIME	= '405';

	gv_cons.SIDE_MENU_ACCORDION = [
		{
			panel	: '.head-menu-ttl-store',
			list	: '.store-area-list__area, .store-area-list__area-ec',
		},
		{
			panel	: '.head-menu-ttl-ec',
			list	: '.head-menu-ec-area',
		},
		{
			panel	: '.head-menu-ttl-epos',
			list	: '.head-menu-epos-area',
		},
		{
			panel	: '.head-menu-ttl-pv',
			list	: '.head-menu-pv-area',
		},
		{
			panel	: '.head-menu-ttl-service',
			list	: '.head-menu-ttl-service-area',
		},
		{
			panel	: '.head-menu-ttl-csr',
			list	: '.head-menu-csr-area',
		},
		{
			panel	: '.head-menu-ttl-information',
			list	: '.head-menu-information-area',
		},
		{
			panel	: '.head-menu-ttl-ir',
			list	: '.head-menu-ir-list',
		},
		{
			panel	: '.head-menu-ttl-life-support',
			list	: '.head-menu-life-support-list',
		},
		{
			panel	: '.head-menu-ttl-group',
			list	: '.head-menu-group-list',
		},
		{
			panel	: '.product-title',
			list	: '.product',
		},
		{
			panel	: '.ec-rote-title',
			list	: '.ec-rote',
		}
	];

	gv_cons.DECISION_PAGE_TYPE = {
		'top'			: [/^\/$/, /^\/index\.html$/],
		'store-top'		: [/^\/\d{3}\/$/, /^\/\d{3}\/index.html$/],
	};

	/** リンク先URLに'/smp'を付ける条件 */
	gv_cons.ADD_SMP_URL_REGEXP_LIST = [
		/^\/203\/.*/,
		/^\/403\/info\/.*/,
		/^\/shitadori\/.*/,
		/^\/voi\/guide\/.*/
	];

	gv_cons.ADD_SMP_URL_REGEXP_TRANSER = /^https?.*\/transer\/transer_..\.html.*/;

	gv_cons.BASE_ANIMATION = {
		easing: 'easeInOutQuart',
		duration: 500,
	};

	/**
	 * パラメータ一括指定
	 */
	gv_cons.PARAM_KEY_COND = {
		'voi.0101.co.jp'				: 'voi',
		'search-voi.0101.co.jp'			: 'voi',
		'shoeslabo.0101.co.jp'			: 'voi',
		'www.eposcard.co.jp'			: 'epos',
		'epotoku.eposcard.co.jp'		: 'epos',
		'/cards/epos/link_gn.html'		: 'epos',
		'/cards/epos/top_left1.html'	: 'epos',
		'/cards/epos/top_left3.html'	: 'epos',
		'/cards/epos/top_left11.html'	: 'epos',
		'www.0101maruigroup.co.jp/' 	: 'group'
	};

	gv_cons.PARAM_KEY_GROUP = {
		'epos'	: 'cid',
		'voi'	: 'cid',
		'group' : 'cid',
		'marui'	: 'from',
	};

	gv_cons.PARAM_HEAD_STR = {
		'marui'	: '01',
		'voi'	: 'oio_voi',
		'epos'	: 'oio_epos',
		'group' : 'oio_group'
	};

	gv_cons.CONV_PARAM_PAGE_KEY = {
		'storeTop'				    : 'top',
		'shopGuideCategory'		: 'guide-category',
		'shopGuideInitial'		: 'guide-initial',
		'shopGuideFloor'		  : 'guide-floor',
		'shopGuideSize'			  : 'guide-size',
		'shopNewsList'			  : 'shop-news-list',
		'shopNewsTargetList'	: 'shop-news-target',
		'shopNewsDetail'	  	: 'shop-news-detail',
		'shopDetail'			    : 'shop-detail',
		'storeArticleList'		: 'store-news-list',
		'storeArticleFair'		: 'store-news-fair',
		'storeArticleNews'		: 'store-news-topics',
		'storeArticleFeature'	: 'store-news-feature',
		'storeAccess'			    : 'access',
		'storeEvent'			    : 'event',
		'storeEventSpace'	  	: 'event-space',
		'storeEventDetail'    : 'event-detail',
		'couponList'			    : 'coupon-list',
		'couponDetail'		  	: 'coupon-detail',
		'facility'			     	: 'facility',
		'facilityInfo'		  	: 'facility-info',
		'facilityTel'			    : 'facility-tel',
		'restaurant'		     	: 'restaurant',
		'beauty'			      	: 'beauty',
		'recruit'			      	: 'recruit',
		'campaign'		    		: 'campaign',
		'shopMail'		    		: 'shop-mail',
		'animeTop'			    	: 'anime-top',
		'otherStore'	    		: 'other-store',
		'otherStoreDetail'		: 'other-store-detail',
		'otherStoreCouponDetail': 'other-store-coupon',
		'otherStoreNewsDetail'  : 'other-store-news',
		'otherStoreNewsTargetList': 'other-store-target',
		'saleCampaignList'  : 'sale-campaign-list',
		'saleCampaignDetail': 'sale-campaign-detail',
		'newsList_v1' : 'news-list',
		'newsDetail_v1': 'news-detail',
		'recommendList' : 'recommend-list',
		'recommendDetail' : 'recommend-detail',
		'featureList'     : 'fearture-list',
		'featureDetail'   : 'feature-detail',
		'featureStatic'   : 'feature-static',
		'storeTopics'     : 'store-topics',
 	};

	gv_cons.PARAM_COMMON_MASTER = {
		'.head-logo'					: 'head_logo',
		'.h-language-jp'				: 'head_lang-ja',
		'.h-language-en'				: 'head_lang-en',
		'.h-language-zh'				: 'head_lang-zh',
		'.h-language-cn'				: 'head_lang-cn',
		'.h-language-ko'				: 'head_lang-ko',
		'.h-nav-voi'					: 'head_voi',
		'.ft-nav-top'					: 'foot_top',
		'.foot-top-store-list'			: 'foot_store',
		'.ft-nav-ec'					: 'foot_voi',
		'.ft-nav-card'					: 'foot_epos',
		'.foot-bottom-nav-list'			: 'foot_about',
		'.head-menu .head-menu-store-list'			: 'menu_store',
		'.head-menu-ttl-shop-search'	: 'menu_shop-search',
		'.head-menu-ec-list'			: 'menu_ec',
		'.head-menu-epos-list'			: 'menu_epos',
		'.head-menu-pv-list'			: 'menu_pv',
		'.head-menu-ttl-line'			: 'menu_line',
		'.head-menu-ttl-marui-anime'	: 'menu_anime',
		'.head-menu-ttl-rakuchin-shoes'	: 'menu_rakuchin',
		'.head-menu-ttl-premium-friday'	: 'menu_friday',
		'.head-menu-service-list'		: 'menu_service',
		'.head-menu-csr-list'			: 'menu_csr',
		'.head-menu-information-list'	: 'menu_info',
		'.head-menu-ir-list'			: 'menu_ir',
		'.head-menu-life-support-list'	: 'menu_support',
		'.head-menu-group-list'			: 'menu_group',

		'.store-head-menu-store-name'	: 'head_logo',
		'.store-nav-info'				: 'sp-head_info',
		'.store-nav-access'				: 'sp-head_access',
		'.store-head-menu .store-area-shop-list__item'	: 'pc-head_nav',
		'.left-menu'					: 'pc-left',
		'.left-bnr'						: 'pc-sbnr',
		'.store-menu-info'				: 'stmenu_info',
		'.store-menu-access'			: 'stmenu_access',
		'.store-menu-event'				: 'stmenu_event',
		'.store-menu-floor'				: 'stmenu_floor',
		'.store-menu-facility'			: 'stmenu_facility',
		'.store-menu-gourmet'			: 'stmenu_gourmet',
		'.store-menu-store-news'		: 'stmenu_store',
		'.store-menu-shop-news'			: 'stmenu_shop',
		'.store-menu-epos'				: 'stmenu_epos',
		'.store-menu-beauty'			: 'stmenu_beauty',
		'.store-menu-shop-mail'			: 'stmenu_mail',
		'.store-menu-recruit'			: 'stmenu_recruit',
		'.store-small-bnr'				: 'stmenu_sbnr',
		'#breadcrumb'					: 'breadcrumb',
		'.gnavi-btm-bnr-list__item'		: 'gnavi',
		'#announce2'					: 'gnav_bottom',
		'.store-area-list__area'        : 'head_nav'
	};

	gv_cons.PARAM_PAGE_MASTER = {
		'top' : {
			'.ttop-rote-list__item:not(.slick-cloned)'		: 'rote_【idx】',
			'.ttop-menu-store-list'							: 'search_store',
			'.ttop-menu-shop-search'						: 'search_shop',
			'.ttop-menu-ec'									: 'search_voi',
			'.ttop-menu-epos'								: 'search_epos',
			'.news-list__item'								: 'news_【idx】',
			'.product-rote-list__item:not(.slick-cloned)'	: 'product_【idx】',
			'.ec-rote-mypage-link'							: 'ec_mypage',
			'.ec-rote-list'									: 'ec_【idx】',
			'.personalize-list__item'						: 'personalize_list',
			'.personalize-store-btn'						: 'personalize_btn',
			'.personalize-store'							: 'personalize_sttop',
		},
		'storeTop' : {
			'.store-top-rote-list__item:not(.slick-cloned)'			: 'rote_【idx】',
			'.store-contents-nav-list__item.contents-nav-floor'		: 'search-floor',
			'.store-contents-nav-list__item.contents-nav-search'	: 'search-search',
			'.store-contents-nav-list__item.contents-nav-gourmet'	: 'search-gourmet',
			'.store-top-event-list__item'							: 'event_list',
			'.store-top-event-btn'									: 'event_btn',
			'.store-top-coupon-area'								: 'coupon',
			'.store-top-store-news-list__item'						: 'store_list',
			'.store-top-store-news-btn'								: 'store_btn',
			'.store-top-shop-news-list__item'						: 'shop_list',
			'.store-top-shop-news-btn'								: 'shop_btn',
			'.store-top-service-bnr-list__item.list__item-service'	: 'service-facility',
			'.store-top-service-bnr-list__item.list__item-epos'		: 'service-epos',
			'.store-top-service-bnr-list__item.list__item-member'	: 'service-member',
			'.store-top-service-bnr-list__item.list__item-send'		: 'service-send',
			'.store-top-middle-bnr-list__item'						: 'mbnr',
			'.news-list__item'										: 'news_【idx】',
			'.store-top-ec-info-my-page'							: 'ec_mypage',
			'.ec-info-list__item'									: 'ec_【idx】',
			'.news-topics-detail-list__item'						: 'news-topics',
			'.pickup-rote__item'                        : 'pickup_rote【idx】',
			'.event-rote__item'                         : 'popup_rote【idx】',
			'.store-topics-feature-list__item'          : 'topics_feature',
			'.store-topics-sale-list__item'             : 'topics_sale',
			'.store-topics-column-list__item'           : 'topics_column',
			'.store-recommend-list__item'               : 'topics_recommend',
			'.store-news-list__item'                    : 'topics_news',
			'.store-future-list__item'                  : 'activity'
		},
		'shopGuideFloor' : {
			'.guide-area-accordion-shop__item'		: 'list',
		},
		'shopGuideCategory' : {
			'.guide-area-accordion-shop__item'		: 'list',
		},
		'shopGuideInitial' : {
			'.guide-area-accordion-shop__item'		: 'list',
		},
		'shopGuideSize' : {
			'.guide-area-size-bnr-btn'				: 'btn',
			'.guide-area-accordion-shop__item'		: 'list',
		},
		'shopDetail' : {
			'.sd-content-main-txt'					: 'intro_txt',
			'.sd-content-main-table'				: 'intro_table',
			'.tmpl-shop-news-list__item'			: 'list_article',
			'.listArea-btn'							: 'list_btn',
			'.apiListArea-bnr'						: 'voi_bnr',
		},
		'shopNewsList' : {
			'.shop-news-list__item'					: 'list_article',
		},
		'shopNewsDetail' : {
			'.shop-news-head-detail'				: 'ttl',
			'.shop-news-content-main'				: 'article_txt',
			'.shop-news-content-btn'				: 'btn',
			'.tmpl-shop-news-list__item'			: 'list_article',
			'.listArea-btn'							: 'list_btn',
			'.anime-bnr-area'						: 'anime_link',
			'.sub__item-detail-main-ec'				: 'post_item',
		},
		'shopNewsTargetList' : {
			'.shop-news-head-detail'				: 'ttl',
			'.shop-news-list__item'					: 'list_article',
		},
		'storeArticleList' : {
			'.tmpl-store-article-list__item'		: 'list_article',
		},
		'storeArticleFair' : {
			'.store-info-content-main'				: 'article_txt',
			'.tmpl-store-article-list__item'		: 'list_article',
			'.anime-ec-area-list__item'				: 'anime_ec_item',
			'.anime-ec-area-link-btn'				: 'anime_ec_link',
			'.anime-bnr-area'						: 'anime_link',
		},
		'storeArticleNews' : {
			'.store-info-content-main'				: 'article_txt',
			'.tmpl-store-article-list__item'		: 'list_article',
			'.anime-ec-area-list__item'				: 'anime_ec_item',
			'.anime-ec-area-link-btn'				: 'anime_ec_link',
			'.anime-bnr-area'						: 'anime_link',
		},
		'storeArticleFeature' : {
			'.feature-txt'							: 'article_txt',
			'.listArea__item'						: 'ft-list_article_【num】',
			'.tmpl-store-article-list__item'		: 'list_article',
			'.anime-ec-area-list__item'				: 'anime_ec_item',
			'.anime-ec-area-link-btn'				: 'anime_ec_link',
			'.anime-bnr-area'						: 'anime_link',
		},
		'facilityInfo' : {
			'.info-addressArea-btn'					: 'address_btn',
			'.info-telArea-btn'						: 'tel_btn',
		},
		'storeAccess' : {
		},
		'storeEvent' : {
			'.tmpl-store-article-list__item'		: 'list_article',
		},
		'facility' : {
			'.facility-biycle-list__detail-linkBtn'	: 'biycle_btn',
			'#contact .btn'							: 'contact',
		},
		'facilityTel' : {
			'.shop-item__epos-center-link'			: 'contact-epos',
		},
		'restaurant' : {
			'.restaurant-list__item'				: 'list',
		},
		'beauty' : {
			'.beauty-list__item'					: 'list',
		},
		'recruit' : {
			'.recruit-list-link'					: 'list',
		},
		'couponList' : {
			'.tmpl-shop-news-list__item'			: 'list',
		},
		'couponDetail' : {
			'.coupon-head-detail'					: 'ttl',
			'.coupon-foot__shop-link'				: 'btn',
			'.tmpl-shop-news-list__item'			: 'list_article',
		},
		'campaign' : {
			'.campaign-list__item'					: 'list_【num】',
			'.campaign-bnr-list__item'				: 'bnr',
			'.campaign-other-store-list__item'		: 'other-store',
		},
		'shopMail' : {
			'.shop-news-list__item'					: 'list',
		},
		'animeTop' : {
			'.anime-rote-list__item:not(.slick-cloned)'	: 'rote_【idx】',
			'.anime-article-list'					: 'event-open',
			'.anime-future-article-list'			: 'event-future',
			'.anime-middle-bnr-list'				: 'mbnr',
			'#animelogoArea h1'						: 'logo',
			'.anime-ec-bnr'							: 'ecbnr',
		},
		'anime-contents' : {
			'.c-article'							: 'article【num】',
			'.ec-list-list'							: 'ec-item【num】',
			'.ec-list__link'						: 'ec-link【num】',
			'.c-head-txt2'							: 'head-text【num】'
		},
		'otherStore' : {
			'.info-link-btn'						: 'top-list'
		},
		'otherStoreDetail': {
			'.shop-coupon-list__item.coupon-detail'	: 'shop-detail',
			'.tmpl-shop-news-list__item'			: 'shop-detail'
		},
		'otherStoreCouponDetail': {
			'.c-head-box'							: 'coupon-head',
			'.c-other-list__item'					: 'coupon-list'
		},
		'otherStoreNewsDetail': {
			'.c-head-box'							: 'shop-news-head',
			'.c-other-list__item'					: 'shop-news-list'
		},
		'otherStoreNewsTargetList': {
			'.c-head-box'							: 'target-store-head',
			'.c-other-list__item'					: 'target-store-list'
		},
		'saleCampaignList' : {
			'.list__item' : 'list'
		},
		'saleCampaignDetail' : {
			'.shopnews-shop': 'detail',
			'.sale-list .list__item' : 'detail-other',
		},
		'newsList_v1' : {
			'.list__item': 'list',
		},
		'newsDetail_v1' : {
			'.txt-wrap'  : 'article-link',
			'.list__item': 'detail-list',
		},
		'storeEventDetail' : {
			'.event-list .list__item': 'detail-other'
		},
		'conceptshops' : {
			'.shop-list': 'conceptshops-list'
		}
	};

	gv_cons.PAGE_PARAM_ARTICLE_ID = {
		'storeArticleFeature'	: 'article_id',
		'campaign' 				: 'campaign_id',
		'anime-contents'			: 'contents_id',
	};

	gv_cons.WIDGET_BASEURI_TRIPADVISOR = 'https://www.jscache.com/wejs?wtype=rated&amp;uniq=${UNIQ}&amp;locationId=${LOCATION}&amp;lang=en_US&amp;display_version=2';

	gv_cons.WIDGET_TRIPADVISOR_UNIQ		= '${UNIQ}';
	gv_cons.WIDGET_TRIPADVISOR_LOCATION	= '${LOCATION}';

	gv_cons.WIDGET_TRIPADVISOR_STORE	= {
		'086'	: {
			uniq 		: '847',
			locationId	: '1838946',
		},
		'090' : {
			uniq 		: '917',
			locationId	: '12851310',
		},
	};

	gv_cons.CID_PARAM_DOMAIN = {
		'www.eposcard.co.jp'		: 'epos',
		'epotoku.eposcard.co.jp'	: 'epos',
		'voi.0101.co.jp'			: 'voi',
		'search-voi.0101.co.jp'		: 'voi'
	};


})();
